<script setup lang="ts">
definePageMeta({
  layout: 'landing',
  smoothScroll: true,
})

const { t } = useI18n()

// Labels reuse the keys LandingNav links these destinations with, so a crumb
// never disagrees with the page it points at.
const { crumbs } = useBreadcrumbs([
  { label: t('label.home'), to: '/' },
  { label: t('page.home.contact_us') },
])

useHead({
  titleTemplate: (chunk) => chunk || 'bookforme',
  title: () => `bookforme — ${t('page.contact_us.title')}`,
  meta: [
    { name: 'description', content: 'Get in touch with the bookforme team. We\'re here to help with technical issues, product feedback, or business plan details.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: () => `bookforme — ${t('page.contact_us.title')}` },
    { property: 'og:description', content: 'We\'re here to help. Let\'s start a conversation.' },
    { property: 'og:site_name', content: 'bookforme' },
    { name: 'twitter:card', content: 'summary_large_image' },
  ],
})
</script>

<template>
  <div>
    <CommonBreadcrumbs :items="crumbs" />

    <LandingContactUs />
  </div>
</template>
